import PropTypes from 'prop-types';
import React from 'react';

import Silk from 'modules/Common/components/Silk';
import BetLink from 'modules/Common/containers/BetLink';
import {localTimeShort} from 'utils/LocalDateTimeHelper';

export default function HorseRacingNextRaceLine(props) {
  const ride = props.ride;
  const betlinkIds = ride.ride_reference.external_reference.filter(r => r.ref === 'skybet').map(r => r.value);

  let betLinkProps;
  if(betlinkIds.length > 0 && ride.betting.current_odds){
    const {
      market_reference: {
        external_reference: [
          {
            value: marketId
          } = {}
        ] = []
      } = {}
    } = props.ride.betting;

    const displayTime = localTimeShort(`${props.raceSummary.date}T${props.raceSummary.time}Z`);

    betLinkProps = {
      marketId,
      eventId: props.raceExternalId,
      eventName: `${displayTime} ${props.raceSummary.course_name}`,
      eventCompetition: props.raceSummary.course_name, // only relevant for feature "integrated-betslip"
      dateTime: `${props.raceSummary.date} ${props.raceSummary.time}`,
      sport: "horseRacing",
      betId: betlinkIds[0],
      betName: ride.horse.name,
      odds: ride.betting.current_odds,
      eachWay: props.eachWay, // only relevant for feature "integrated-betslip"
      suspended: props.suspended, // only relevant for feature "integrated-betslip"
      fixture: props.fixture, // only relevant for feature "integrated-betslip"
      startingPriceAvailable: ride.has_sp // only relevant for feature "integrated-betslip"
    };
  }

  require('./HorseRacingNextRaceLine.scss');
  return (
    <div key={ride.horse.horse_reference.id} className="next-race-off-list-item">
      <div className="next-race-off-saddle-stall-info">
        <div className="row">
          <span className="next-race-off-saddle-cloth-no">{ride.cloth_number || 0}</span>
        </div>
        <div className="row">
          <span className="next-race-off-stall-no">({ride.draw_number || 0})</span>
        </div>
      </div>
      <div className="next-race-off-silks">
        <Silk filename={ride.silk_filename}/>
      </div>
      <div className="next-race-off-names">
        <div className="next-race-off-horse">{ride.horse.name || "Unknown"}</div>
        <div className="next-race-off-jockey"><b>J:</b> {ride.jockey.name || "Unknown"}</div>
      </div>
      <div className="next-race-off-betting-odds">
        { !!betLinkProps &&
          <BetLink className='next-race-off-betting-link sui-odds' {...betLinkProps}>{betLinkProps.odds}</BetLink>
        }
      </div>
    </div>
  );
}

HorseRacingNextRaceLine.propTypes = {
  ride: PropTypes.shape({
    horse: PropTypes.shape({
      horse_reference: PropTypes.shape({
        id: PropTypes.number.isRequired
      }).isRequired,
      name: PropTypes.string
    }).isRequired,
    cloth_number: PropTypes.number,
    draw_number: PropTypes.number,
    jockey: PropTypes.shape({
      name: PropTypes.string
    }).isRequired,
    betting: PropTypes.shape({
      current_odds: PropTypes.string,
      market_reference: PropTypes.shape({
        external_reference: PropTypes.arrayOf(PropTypes.shape({
          value: PropTypes.string
        }))
      })
    })
  }).isRequired,
  raceSummary: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
    course_name: PropTypes.string
  }),
  eachWay: PropTypes.object,
  suspended: PropTypes.bool,
  fixture: PropTypes.string,
  raceExternalId: PropTypes.string
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingNextRaceLine.js